import styled from 'styled-components';
import { Snackbar as MaterialSnackbar } from '@mui/material';

export const StyledSnackbar = styled(MaterialSnackbar).attrs(({ type, ...rest }) => rest)`
  z-index: 10004 !important;

  div {
    background-color: ${({ theme, type }) => theme.colors?.[type] || '#333'};
  }
`;

export const Message = styled('span')``;
